// Admin dates in the viewer's own time zone (T31). Server timestamps are
// ISO-8601 UTC strings.

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const EMPTY = '—';

const toDate = (value) => {
  if (value == null || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

// "Jun 16, 2026"
export const formatDate = (value) => {
  const d = toDate(value);
  if (!d) return EMPTY;
  return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

// "7:30 PM"
export const formatTime = (value) => {
  const d = toDate(value);
  if (!d) return EMPTY;
  const h = d.getHours();
  const m = String(d.getMinutes()).padStart(2, '0');
  return `${h % 12 || 12}:${m} ${h < 12 ? 'AM' : 'PM'}`;
};

// "Jun 16, 2026 · 7:30 PM"
export const formatDateTime = (value) => {
  const d = toDate(value);
  if (!d) return EMPTY;
  return `${formatDate(d)} · ${formatTime(d)}`;
};
